import { Logger, Presenter } from 'wdc-cube'
import type { MercadoVetPresenter } from './mv_presenter'
import MvSearchBarPresenter from './mv_presenter_search_bar'
import { LinkedInPageScope } from './mv_scopes'
import { MercadoVetService } from './mv_service'
import type { VetFilter } from './mv_types'
import { errorMessage } from './mv_utils'

const LOG = Logger.get('MV-Presenter-LinkedIn')

const service = MercadoVetService.singleton()

export default class MvLinkedInPresenter extends Presenter<LinkedInPageScope, MercadoVetPresenter> {
    constructor(owner: MercadoVetPresenter) {
        super(owner, owner.scope.linkedin)
        this.searchBar = new MvSearchBarPresenter(this, this.scope.busca, {
            placeholder: 'Filtrar por CNPJ, empresa, pessoa ou cargo',
            aoDigitar: true
        })
    }

    readonly searchBar: MvSearchBarPresenter

    private __request = 0
    private __filterKey = ''

    override release() {
        this.searchBar.release()
        super.release()
    }

    initialize() {
        this.searchBar.initialize()
    }

    async onBuscaChanged(texto: string) {
        this.scope.filtro = texto
    }

    async activate(filter: VetFilter) {
        const key = JSON.stringify(filter)
        if (key === this.__filterKey && this.scope.loaded) return
        this.__filterKey = key
        await this.__fetch(filter)
    }

    invalidate() {
        this.__filterKey = ''
    }

    private async __fetch(filter: VetFilter) {
        const s = this.scope
        const requestId = ++this.__request
        s.loading = true
        try {
            const resp = await service.fetchContatos(filter)
            if (requestId !== this.__request) return
            s.erro = ''
            s.rows = resp.rows
            s.total = resp.total
            s.empresasComContato = resp.empresasComContato
        } catch (caught) {
            if (requestId !== this.__request) return
            LOG.error('fetchContatos', caught)
            s.erro = errorMessage(caught)
        } finally {
            if (requestId === this.__request) {
                s.loading = false
                s.loaded = true
            }
        }
    }
}
